import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGS, LANG_LABELS, type Lang } from '../i18n'

/**
 * Селектор языка. Меняет язык через i18n (сохраняется в localStorage детектором).
 * className/style прокидываются, чтобы вписать в шапку, подвал или мобильное меню.
 */
export function LanguageSwitcher({
  className,
  style,
}: {
  className?: string
  style?: React.CSSProperties
}) {
  const { i18n, t } = useTranslation()
  const current = (i18n.resolvedLanguage || i18n.language || 'ru').split('-')[0] as Lang
  const value: Lang = (SUPPORTED_LANGS as readonly string[]).includes(current) ? current : 'ru'

  return (
    <select
      className={className}
      value={value}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      aria-label={t('language.label')}
      style={style}
    >
      {SUPPORTED_LANGS.map((code) => (
        <option key={code} value={code}>
          {LANG_LABELS[code]}
        </option>
      ))}
    </select>
  )
}
